// Animated voice-agent indicator orb for chat/notebook pages
// Uses ElevenLabs UI Orb component (Three.js WebGL, audio-reactive)
import { Orb, type AgentState } from '@/components/ui/orb'

interface VoiceOrbProps {
  active?: boolean
  agentState?: AgentState
  size?: number
  className?: string
}

export function VoiceOrb({
  active = false,
  agentState,
  size = 48,
  className,
}: VoiceOrbProps) {
  // Derive agentState from the active flag if not explicitly provided
  const resolvedState: AgentState = agentState ?? (active ? 'listening' : null)

  return (
    <div
      className={`overflow-hidden rounded-full ${className ?? ''}`}
      style={{ width: size, height: size }}
    >
      <Orb
        colors={['#7c3aed', '#a78bfa']}
        agentState={resolvedState}
        className="h-full w-full"
      />
    </div>
  )
}
